import { render, staticRenderFns } from "./TifTurnoIndex.vue?vue&type=template&id=8cdad8e2"
import script from "./TifTurnoIndex.vue?vue&type=script&lang=js"
export * from "./TifTurnoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports